import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import categoryClient from './apis/apis.client';
import categoryQueryKeys from './queryKeys';
import type { CategoryListResponse } from './type';

type QueryOptions<T> = Omit<UseQueryOptions<T>, 'queryKey' | 'queryFn'>;

export function useGetCategoryList(options?: QueryOptions<CategoryListResponse>) {
  return useQuery({
    queryKey: categoryQueryKeys.lists(),
    queryFn: categoryClient.getList,
    ...options,
  });
}
